import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vehicles/Data Table Component";
import Add_data_modal from "../../components/vehicles/update_data_modal/index";
import VehicleDetailModal from "../../components/vehicles/DisplayData";
import Swal from "sweetalert2";
import { Badge, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatDistanceToNow } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Layouts from "../../layouts/layouts";
import VehicleHistory from "./vehiclehistory";
import * as XLSX from "xlsx";
import { extractCityFromLocation } from "../../utils/extractCity";
import {
  faPenToSquare,
  faTrash,
  faCopy,
  faEye,
  faHistory,
  faInfoCircle,
  faLocationDot,
  faPlay,
  faPause,
  faTruck,
  faUser,
  faBolt,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
const LiveLocationCell = ({ row }) => {
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ RESET ADDRESS WHEN ROW CHANGES
  useEffect(() => {
    setAddress(null);
    setLoading(false);
  }, [row._id]);

  const fetchAddress = async () => {
    if (!row.livecoordinates) {
      setAddress("No coordinates available");
      return;
    }

    const { latitude, longitude } = row.livecoordinates;

    setLoading(true);

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_BASE_API}`,
      );

      const data = await res.json();

      if (data.status === "OK" && data.results.length > 0) {
        setAddress(data.results[0].formatted_address);
      } else {
        setAddress("Address not found");
      }
    } catch (err) {
      console.error("Error fetching address:", err);
      setAddress("Error fetching address");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "relative", zIndex: 1 }}>
      {address ? (
        <>
          <span>{address.slice(0, 20)}...</span>

          <FontAwesomeIcon
            icon={faInfoCircle}
            data-tooltip-id={`tooltip-live-location-${row._id}`}
            data-tooltip-content={address}
            style={{ cursor: "pointer", marginLeft: "5px" }}
          />

          <Tooltip
            id={`tooltip-live-location-${row._id}`}
            place="bottom"
            style={{ zIndex: 9999, backgroundColor: "black" }}
          />
        </>
      ) : (
        <button
          onClick={fetchAddress}
          disabled={loading}
          style={{
            padding: "4px 8px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          {loading ? "Loading..." : "Click"}
        </button>
      )}
    </div>
  );
};

export default function Vehicle() {
  const navigate = useNavigate();
  const title = "Vehicles Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [vehicleCount, setVehicleCount] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [serviceCenterCount, setServiceCenterCount] = useState(0);
  const [dashboardCounts, setDashboardCounts] = useState({
    moving: 0,
    notMoving: 0,
    checkedIn: 0,
    total: 0,
  });

  const [filter, setFilter] = useState("all");
  const [dataFilter, setDataFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [vehicleCompanyFilter, setVehicleCompanyFilter] = useState("");
  const [hubFilter, setHubFilter] = useState([]);
  const [monthFilter, setMonthFilter] = useState("");
  const [ticketCategoryFilter, setTicketCategoryFilter] = useState("");

  const [ticketAgingFilter, setTicketAgingFilter] = useState("");
  const [leasingPartnerFilter, setLeasingPartnerFilter] = useState("");
  const [ticketPendingReasonFilter, setTicketPendingReasonFilter] =
    useState("");
  const [vehicleSummaryCompanyFilter, setVehicleSummaryCompanyFilter] =
    useState("");

  const [vehicleFeetFilter, setVehicleFeetFilter] = useState("");
  const [leasingPartners, setLeasingPartners] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5); // IMPORTANT
  const [totalRows, setTotalRows] = useState(0);
  const [fullData, setFullData] = useState([]);
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showVehicleDetailModal, setShowVehicleDetailModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [selectedTicketComments, setSelectedTicketComments] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [data, setData] = useState([]);
  const brad = [{ name: "Home" }, { name: title }];
  const excludedStatuses = ["Inactive", "Unassigned", "Service_Center"];
  const userRole = localStorage.getItem("userRole"); // Get user role
  const [trackingAvailability, setTrackingAvailability] = useState(() => {
    const saved = localStorage.getItem("trackingAvailabilityMap");
    return saved ? JSON.parse(saved) : {};
  });

  const checkTrackingAvailabilityForVehicles = async (vehicles) => {
    const token = localStorage.getItem("token");
    const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
    const results = {};

    for (const vehicle of vehicles) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicleHistory/vehicle/${vehicle._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = res.data.vehicleHistory || [];

        const hasTodayData = data.some((entry, idx) => {
          const rawDate = entry?.lastDate;
          const coords = entry?.coordinates;

          if (!rawDate) {
            console.warn(
              `🚫 Entry[${idx}] for vehicle ${vehicle._id} has no lastDate`,
            );
            return false;
          }

          const entryDate = new Date(rawDate).toISOString().slice(0, 10);
          const validCoords =
            coords?.latitude &&
            coords?.longitude &&
            coords.latitude !== 0 &&
            coords.longitude !== 0;

          return entryDate === today && validCoords;
        });

        results[vehicle._id] = hasTodayData;
      } catch (err) {
        console.error(`❌ Error for vehicle ${vehicle._id}:`, err);
        results[vehicle._id] = false;
      }
    }

    setTrackingAvailability(results);
    localStorage.setItem("trackingAvailabilityMap", JSON.stringify(results)); // 🔐 Save
  };

  const isToday = (dateString) => {
    if (!dateString) return false;

    const today = new Date();
    const dateToCheck = new Date(dateString);

    return (
      today.getDate() === dateToCheck.getDate() &&
      today.getMonth() === dateToCheck.getMonth() &&
      today.getFullYear() === dateToCheck.getFullYear()
    );
  };

  const formatTime = (dateString) => {
    if (!dateString) {
      return "N/A";
    }
    const formattedTime = moment(dateString).format("HH:mm:ss");
    return formattedTime;
  };
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };

  useEffect(() => {
    const fetchLeasingPartners = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) return;

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/leases`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (Array.isArray(response.data.leases)) {
          const partners = [
            ...new Set(
              response.data.leases
                .map((lease) => lease.leasing_partner)
                .filter(Boolean)
                .map((partner) => partner.trim()),
            ),
          ].sort((a, b) => a.localeCompare(b));

          setLeasingPartners(partners);
        }
      } catch (error) {
        console.error("Error fetching leasing partners:", error);
      }
    };

    fetchLeasingPartners();
  }, []);
  const columns = [
    {
      name: <b>Tracking</b>,
      cell: (row) => {
        const hasTracking = trackingAvailability[row._id] === true;

        return (
          <button
            onClick={() => handleTrackingClick(row)}
            className={`btn btn-sm ms-1 ${
              hasTracking ? "btn-success" : "btn-danger"
            }`}
            title={hasTracking ? "Tracking Available" : "Tracking Unavailable"}
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        );
      },
      width: "100px",
    },
    {
      name: <b>Number Plate</b>,
      selector: (row) => row.numberplate,
      sortable: true,
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
          {row.numberplate}
        </div>
      ),
    },
    {
      name: <b>Status</b>,
      cell: (row) => {
        const status = row.status?.toLowerCase();
        return (
          <button
            onClick={() => handleShow(row)}
            className={`btn px-2 py-1 ${
              // Adjusted padding for space
              status === "active"
                ? "btn-success"
                : status === "inactive"
                  ? "btn-danger"
                  : status === "unassigned"
                    ? "btn-danger"
                    : status === "service_center"
                      ? "btn-warning"
                      : ""
            }`}
            style={{
              minWidth: "70px", // Increased minimum width to fit longer text
              fontSize: "14px", // Adjust font size if needed
              whiteSpace: "nowrap", // Prevents text from wrapping to new lines
            }}
          >
            {row.status || "Unknown"}
          </button>
        );
      },
      // Adding width for the column itself to avoid overlap
      width: "150px", // Adjust width as needed
    },

    // ============================================
    // SERVICE CENTER COLUMNS
    // ============================================
    ...(statusFilter === "Service_Center"
      ? [
          {
            name: <b>Category</b>,
            selector: (row) => row.latestTicket?.category?.name || "N/A",
            sortable: true,
            cell: (row) => (
              <div>{row.latestTicket?.category?.name || "N/A"}</div>
            ),
          },

          {
            name: <b>Aging</b>,
            selector: (row) => row.latestTicket?.aging ?? 0,
            sortable: true,
            cell: (row) => <div>{row.latestTicket?.aging ?? 0} Days</div>,
          },

          {
            name: <b>Pending Reason</b>,
            selector: (row) => row.latestTicket?.pendingissue || "N/A",
            sortable: true,
            width: "150px",
            cell: (row) => (
              <div
                style={{
                  width: "100%",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  lineHeight: "18px",
                  padding: "5px 0",
                }}
                title={row.latestTicket?.pendingissue || "N/A"}
              >
                {row.latestTicket?.pendingissue || "N/A"}
              </div>
            ),
          },
        ]
      : []),

    {
      name: <b>Feet</b>,
      selector: (row) => row.id_type?.company || "N/A",
      sortable: true,
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
          {row.id_type?.feet || "N/A"}
        </div>
      ),
    },
    {
      name: <b>On-Boarding Date</b>,
      selector: (row) => formatDate(row.onBoardingDate || "-"),
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={formatDate(row.onBoardingDate || "-")}
        >
          {formatDate(row.onBoardingDate || "-")}
        </div>
      ),
    },
    {
      name: <b>Battery %</b>,
      selector: (row) => {
        const level = Math.round(row.battery_percentage) || 0;
        let color = "green";
        if (level < 40) color = "red";
        else if (level < 75) color = "orange";
        return (
          <span style={{ fontWeight: "bold", color }}>
            🔋 {level}
            <span style={{ color: "#888", fontWeight: "normal" }}> %</span>
          </span>
        );
      },
    },
    {
      name: <b>Daily KM</b>,
      selector: (row) => (
        <span>
          <b>{Math.round(row.dailyKm) || 0}</b>
          <span style={{ color: "#888", fontSize: "0.85rem" }}> km</span>
        </span>
      ),
    },

    {
      name: <b>Company</b>,
      selector: (row) => row.id_type?.company || "N/A",
      sortable: true,
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
          {row.id_type?.company || "N/A"}
        </div>
      ),
    },

    {
      name: <b>Assign Driver</b>,
      cell: (row) => (
        <div>
          {row.id_driver && row.id_driver.length > 0 ? (
            <div>
              {row.id_driver.map((driver) =>
                driver.id_user && driver.id_user.name ? (
                  <Badge key={driver._id} pill bg="white" text="black">
                    {driver.id_user?.name}
                  </Badge>
                ) : (
                  "  N/A"
                ),
              )}
            </div>
          ) : (
            <span>N/A</span>
          )}
        </div>
      ),
      sortable: true,
    },

    {
      name: <b>Last Driver</b>,
      selector: (row) => {
        const name = row.last_driver?.id_user?.name;
        const adhocPhone = row.id_adhocUser?.name;
        return name || adhocPhone || "-";
      },
      sortable: true,
      cell: (row) => {
        const name = row.last_driver?.id_user?.name;
        const adhocPhone = row.id_adhocUser?.name;
        const displayValue = name || adhocPhone || "-";

        return (
          <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
            {displayValue}
          </div>
        );
      },
    },

    {
      name: <b>Current Driver</b>,
      selector: (row) => {
        const name = row.current_driver?.id_user?.name;
        const adhocPhone = row.id_adhocUser?.name;
        return name || adhocPhone || "-";
      },
      sortable: true,
      cell: (row) => {
        const name = row.current_driver?.id_user?.name;
        const adhocPhone = row.id_adhocUser?.name;
        const displayValue = name || adhocPhone || "-";

        return (
          <div style={{ whiteSpace: "nowrap", overflow: "visible" }}>
            {displayValue}
          </div>
        );
      },
    },

    // {
    //   name: <b>Check In</b>,
    //   sortable: true,
    //   cell: (row) => (
    //     <div
    //       style={{
    //         backgroundColor: "#eaf7ff", // soft light blue
    //         padding: "6px 10px",
    //         borderRadius: "4px",
    //         fontWeight: isToday(row.shift_hours?.check_in) ? "600" : "400",
    //       }}
    //     >
    //       {isToday(row.shift_hours?.check_in)
    //         ? formatTime(row.shift_hours?.check_in)
    //         : "-"}
    //     </div>
    //   ),
    // },
    {
      name: <b>Check In</b>,
      sortable: true,
      cell: (row) => {
        const isCheckInToday = isToday(row.shift_hours?.check_in);
        return (
          <div
            style={{
              backgroundColor: isCheckInToday ? "#eaf7ff" : "transparent",
              padding: "6px 10px",
              borderRadius: isCheckInToday ? "4px" : "0px",
              fontWeight: isCheckInToday ? "600" : "400",
            }}
          >
            {isCheckInToday ? formatTime(row.shift_hours?.check_in) : "-"}
          </div>
        );
      },
    },

    {
      name: <b>Check Out</b>,
      sortable: true,
      cell: (row) => {
        const isCheckOutToday = isToday(row.shift_hours?.check_out);
        return (
          <div
            style={{
              backgroundColor: isCheckOutToday ? "#fff4e6" : "transparent",
              padding: "6px 10px",
              borderRadius: isCheckOutToday ? "4px" : "0px",
              fontWeight: isCheckOutToday ? "600" : "400",
            }}
          >
            {isCheckOutToday ? formatTime(row.shift_hours?.check_out) : "-"}
          </div>
        );
      },
    },

    {
      name: <b>Live Location</b>,
      cell: (row) => <LiveLocationCell row={row} />,
      sortable: true,
    },

    {
      name: <b>Vehicle Status</b>,
      selector: (row) => row.vehiclestatus || "N/A",
      sortable: true,
    },
    {
      name: <b>Leasing Partner</b>,
      selector: (row) => row.leaseInfo?.leasing_partner || "N/A",
      sortable: true,
      minWidth: "220px",
      maxWidth: "250px",
      cell: (row) => (
        <div
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={row.leaseInfo?.leasing_partner}
        >
          {row.leaseInfo?.leasing_partner || "-"}
        </div>
      ),
    },
    {
      name: <b>Total KM</b>,
      selector: (row) => Math.round(row.totalkm || 0),
      width: "120px",
    },

    // {
    //   name: <b>Battery Percentage</b>,
    //   selector: (row) => Math.round(row.battery_percentage) || "0",
    // },
    {
      name: <b>Hubs</b>,
      selector: (row) => {
        if (Array.isArray(row.id_hub)) {
          return row.id_hub.map((hub) => hub.name).join(", ");
        } else {
          return "N/A";
        }
      },
      sortable: true,
      width: "180px",
      cell: (row) => {
        const hubs = Array.isArray(row.id_hub)
          ? row.id_hub.map((hub) => hub.name).join(", ")
          : "N/A";

        return (
          <div
            style={{
              width: "100%",
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              lineHeight: "18px",
              padding: "5px 0",
            }}
            title={hubs}
          >
            {hubs}
          </div>
        );
      },
    },
    {
      name: <b>City</b>,
      // cell: (row) => (
      //   <div>
      //     {row.assignedlocation
      //       ? extractCityFromLocation(row.assignedlocation)
      //       : "N/A"}
      //   </div>
      // ),
      cell: (row) => {
        const location =
          typeof row.assignedlocation === "string"
            ? row.assignedlocation
            : JSON.stringify(row.assignedlocation); // or row.assignedlocation.city

        return <div>{extractCityFromLocation(location)}</div>;
      },

      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {userRole === "superadmin" && (
            <>
              <button
                onClick={() => setUpdateStoreBtn(row)}
                className="btn btn-info btn-sm ms-1"
              >
                <FontAwesomeIcon icon={faPenToSquare} />
              </button>
              {/* <button
                onClick={() => delete_row(row)}
                className="btn btn-danger btn-sm ms-1"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button> */}
            </>
          )}
          <button
            onClick={() => viewVehicle(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>

          <button
            onClick={() => handleVehicleHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faLocationDot} />
          </button>

          <button
            onClick={() => handleVehicleAttendanceHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        </>
      ),
      width: "180px",
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleCommentsClick = (row) => {
    const ticket = row.latestTicket;

    if (!ticket) {
      setSelectedTicket(null);
      setSelectedTicketComments([]);
      setShowCommentsModal(true);
      return;
    }

    setSelectedTicket(ticket);
    setSelectedTicketComments(ticket.comments || []);
    setShowCommentsModal(true);
  };

  const fetchData = async (page = 1, limit = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      if (!token) return;

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `/api/v1/vehicles`;
      } else if (userRole === "admin") {
        apiUrl = `/api/v1/hub/admin/vehicles`;
      } else if (userRole === "clientmanager") {
        apiUrl = `/api/v1/hub/client/vehicles`;
      } else return;

      // 🔥 PAGINATED QUERY
      let query = `?page=${page}&limit=${limit}`;
      if (filter !== "all") {
        query += `&dashboardFilter=${filter}`;
      }
      if (dataFilter) query += `&search=${dataFilter}`;
      if (statusFilter) query += `&status=${statusFilter}`;
      if (vehicleCompanyFilter)
        query += `&vehicleCompany=${vehicleCompanyFilter}`;
      if (hubFilter.length > 0) query += `&hub=${hubFilter.join(",")}`;
      if (monthFilter) query += `&onboardMonth=${monthFilter}`;
      if (ticketCategoryFilter) {
        query += `&ticketCategory=${encodeURIComponent(ticketCategoryFilter)}`;
      }
      if (ticketAgingFilter) {
        query += `&ticketAging=${encodeURIComponent(ticketAgingFilter)}`;
      }
      if (ticketPendingReasonFilter) {
        query += `&ticketPendingReason=${encodeURIComponent(
          ticketPendingReasonFilter,
        )}`;
      }

      if (vehicleSummaryCompanyFilter) {
        query += `&vehicleSummaryCompany=${encodeURIComponent(
          vehicleSummaryCompanyFilter,
        )}`;
      }

      if (vehicleFeetFilter) {
        query += `&vehicleFeet=${encodeURIComponent(vehicleFeetFilter)}`;
      }

      if (leasingPartnerFilter) {
        query += `&leasingPartner=${encodeURIComponent(leasingPartnerFilter)}`;
      }
      // 🔥 NON-PAGINATED QUERY (IMPORTANT)
      let fullQuery = `?`;

      if (dataFilter) fullQuery += `search=${dataFilter}&`;
      if (statusFilter) fullQuery += `status=${statusFilter}&`;
      if (vehicleCompanyFilter)
        fullQuery += `vehicleCompany=${vehicleCompanyFilter}&`;
      if (hubFilter.length > 0) fullQuery += `&hub=${hubFilter.join(",")}&`;
      if (monthFilter) fullQuery += `onboardMonth=${monthFilter}&`;

      if (leasingPartnerFilter) {
        fullQuery += `leasingPartner=${encodeURIComponent(
          leasingPartnerFilter,
        )}&`;
      }

      // 🔥 CALL BOTH APIs IN PARALLEL (OPTIMIZED 🚀)
      const [paginatedRes, fullRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BASE_URL}${apiUrl}${query}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${process.env.REACT_APP_BASE_URL}${apiUrl}${fullQuery}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const vehicles = paginatedRes.data.vehicles || [];
      const allVehicles = fullRes.data.vehicles || [];
      console.log("PAGINATED VEHICLE:", vehicles[0]);
      console.log("LATEST TICKET:", vehicles[0]?.latestTicket);
      console.log("CATEGORY:", vehicles[0]?.latestTicket?.category?.name);
      console.log("AGING:", vehicles[0]?.latestTicket?.aging);

      console.log("FULL VEHICLE:", allVehicles[0]);
      console.log("FULL LATEST TICKET:", allVehicles[0]?.latestTicket);
      setDashboardCounts(
        paginatedRes.data.dashboardCounts || {
          moving: 0,
          notMoving: 0,
          checkedIn: 0,
          total: 0,
        },
      );

      // ✅ SORT
      const statusPriority = {
        Active: 1,
        Service_Center: 2,
        Unassigned: 3,
        Inactive: 4,
      };

      const sortByStatus = (data) => {
        const statusPriority = {
          Active: 1,
          Service_Center: 2,
          Unassigned: 3,
          Inactive: 4,
        };

        return [...data].sort((a, b) => {
          const statusA = statusPriority[a.status] || 999;
          const statusB = statusPriority[b.status] || 999;
          return statusA - statusB;
        });
      };

      const sortedVehicles = sortByStatus(vehicles);
      const sortedFullData = sortByStatus(allVehicles);

      setApiState(sortedVehicles);
      setFullData(sortedFullData);

      setVehicleCount(paginatedRes.data.pagination?.totalVehicles || 0);
      setTotalRows(paginatedRes.data.pagination?.totalVehicles || 0);

      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage);
  }, [
    currentPage,
    rowsPerPage,
    dataFilter,
    statusFilter,
    vehicleCompanyFilter,
    hubFilter,
    monthFilter,
    ticketCategoryFilter,
    ticketAgingFilter,
    ticketPendingReasonFilter,
    vehicleSummaryCompanyFilter,
    vehicleFeetFilter,
    leasingPartnerFilter,
    filter,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    dataFilter,
    statusFilter,
    vehicleCompanyFilter,
    hubFilter,
    monthFilter,
    ticketCategoryFilter,
    ticketAgingFilter,
    ticketPendingReasonFilter,
    vehicleSummaryCompanyFilter,
    vehicleFeetFilter,
    leasingPartnerFilter,
  ]);

  useEffect(() => {
    if (apistate.length > 0) {
      checkTrackingAvailabilityForVehicles(apistate);
    }
  }, [apistate]);

  const handleFilterClick = (type) => {
    setCurrentPage(1);
    setFilter(type);
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  // const delete_row = (row) => {
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     Swal.fire("Unauthorized!");
  //     return;
  //   }
  //   Swal.fire({
  //     icon: "warning",
  //     title: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .delete(
  //           `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle/${row._id} `,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           },
  //         )
  //         .then(() => {
  //           Swal.fire("Deleted!", "Vehicle has been deleted.", "success");
  //           fetchData();
  //         })
  //         .catch((error) => {
  //           Swal.fire("Error!", "Vehicle could not be deleted.", "error");
  //         });
  //     }
  //   });
  // };

  const updateVehicle = (updatedVehicle) => {
    setApiState((prev) =>
      prev.map((vehicle) =>
        vehicle._id === updatedVehicle._id ? updatedVehicle : vehicle,
      ),
    );
  };

  const viewVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowVehicleDetailModal(true);
  };

  const handleVehicleHistoryClick = (row) => {
    navigate(`/vehiclehistory/${row._id}`);
  };

  const handleVehicleAttendanceHistoryClick = (row) => {
    navigate(`/vehicleattendancehistory/${row._id}`);
  };

  const handleStatusFilter = (status) => {
    setCurrentPage(1);

    setApiState([]);
    setFullData([]);

    if (status === "ALL") {
      setStatusFilter("");
    } else {
      setStatusFilter(status);
    }
  };

  // const handleTrackingClick = (row) => {
  //   navigate(`/tracking/${row._id}`);
  // };
  const handleTrackingClick = (row) => {
    navigate(`/tracking/${row._id}`, {
      state: { date: new Date().toISOString().slice(0, 10) },
    });
  };

  const exportToExcel = async () => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `/api/v1/vehicles`;
      } else if (userRole === "admin") {
        apiUrl = `/api/v1/hub/admin/vehicles`;
      } else if (userRole === "clientmanager") {
        apiUrl = `/api/v1/hub/client/vehicles`;
      } else {
        return;
      }

      // ❗ NO pagination
      let query = `?`;

      if (dataFilter) query += `search=${dataFilter}&`;
      if (statusFilter) query += `status=${statusFilter}&`;
      if (vehicleCompanyFilter)
        query += `vehicleCompany=${vehicleCompanyFilter}&`;
      if (hubFilter.length > 0) query += `hub=${hubFilter.join(",")}&`;
      if (monthFilter) query += `onboardMonth=${monthFilter}&`;
      if (leasingPartnerFilter) {
        query += `leasingPartner=${encodeURIComponent(leasingPartnerFilter)}&`;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${apiUrl}${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const allVehicles = response.data.vehicles || [];

      const transformedData = allVehicles.map((vehicle) => ({
        "Number Plate": vehicle.numberplate,
        Feet: vehicle.id_type?.feet || "N/A",
        Category: vehicle.latestTicket?.category?.name || "N/A",
        Aging:
          vehicle.latestTicket?.aging != null
            ? `${vehicle.latestTicket.aging} Days`
            : "0 Days",
        "Chassis Number": vehicle.chassisnumber || "N/A",
        "On-Board Date": vehicle.onBoardingDate
          ? formatDate(vehicle.onBoardingDate)
          : "N/A",
        "Vehicle Status": vehicle.vehiclestatus || "N/A",
        "Vehicle Type": vehicle.id_type?.vehiclename || "N/A",
        "Vehicle Company": vehicle.id_type?.company || "N/A",

        Model: vehicle.model || "N/A",
        Year: vehicle.year || "N/A",
        Color: vehicle.color || "N/A",
        Capacity: vehicle.capacity || "N/A",
        Lease: vehicle.lease || "N/A",
        "Leasing Partner": vehicle.leaseInfo?.leasing_partner || "N/A",

        Length: vehicle.length || "N/A",

        "Assigned Drivers":
          vehicle.id_driver?.length > 0
            ? vehicle.id_driver.map((d) => d.id_user?.name || "N/A").join(", ")
            : "N/A",

        "Current Driver": vehicle.current_driver?.id_user?.name || "N/A",

        "Last Driver": vehicle.last_driver?.id_user?.name || "N/A",

        "Hub Names": Array.isArray(vehicle.id_hub)
          ? vehicle.id_hub.map((h) => h.name).join(", ")
          : "N/A",

        City: vehicle.assignedlocation
          ? extractCityFromLocation(
              typeof vehicle.assignedlocation === "string"
                ? vehicle.assignedlocation
                : JSON.stringify(vehicle.assignedlocation),
            )
          : "N/A",
        "Daily KM": vehicle.dailyKm || 0,

        "Total KM": vehicle.totalkm || 0,

        Latitude: vehicle.livecoordinates?.latitude || "N/A",
        Longitude: vehicle.livecoordinates?.longitude || "N/A",

        "Created Date": vehicle.createdAt
          ? formatDate(vehicle.createdAt)
          : "N/A",

        "Modified At": vehicle.updatedAt
          ? formatDate(vehicle.updatedAt)
          : "N/A",

        Status: vehicle.status || "Unknown",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicles");

      XLSX.writeFile(workbook, "VehiclesData.xlsx");
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  const sendServiceCenterEmail = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        Swal.fire("Unauthorized", "Please login again.", "error");
        return;
      }

      // ---------------------------------------------
      // Confirmation + Additional Note
      // ---------------------------------------------
      const result = await Swal.fire({
        title: "Send Service Center Report?",
        html: `
        <p style="margin-bottom: 15px;">
          The report will be sent to the configured email recipients.
        </p>

        <div style="text-align:left;">
          <label
            for="service-center-email-note"
            style="
              display:block;
              font-weight:600;
              font-size:14px;
              color:#333;
              margin-bottom:8px;
            "
          >
            Would you like to add anything to this email?
          </label>

          <textarea
            id="service-center-email-note"
            class="swal2-textarea"
            placeholder="Enter any additional message, note or instruction..."
            style="
              width:90%;
              min-height:120px;
              resize:vertical;
              font-size:14px;
            "
          ></textarea>
        </div>
      `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Send Email",
        cancelButtonText: "Cancel",
        focusConfirm: false,

        preConfirm: () => {
          const note =
            document
              .getElementById("service-center-email-note")
              ?.value?.trim() || "";

          return {
            note,
          };
        },
      });

      if (!result.isConfirmed) {
        return;
      }

      const additionalNote = result.value?.note || "";

      // ---------------------------------------------
      // Loading
      // ---------------------------------------------
      Swal.fire({
        title: "Sending Email...",
        text: "Please wait.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // ---------------------------------------------
      // Send Email
      // ---------------------------------------------
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles/service-center/email`,
        {
          additionalNote,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Email Sent",
        text: "Service Center vehicle report has been sent successfully.",
      });
    } catch (error) {
      console.error("Service Center email error:", error);

      Swal.fire({
        icon: "error",
        title: "Email Failed",
        text:
          error.response?.data?.message ||
          "Failed to send Service Center vehicle report.",
      });
    }
  };

  const getDynamicStyle = (value) => {
    const styles = [
      {
        background: "#f5f3ff",
        border: "#ddd8ff",
        color: "#4723d9",
      },
      {
        background: "#eef7ff",
        border: "#d5e8fb",
        color: "#0878d1",
      },
      {
        background: "#effaf2",
        border: "#d8efdc",
        color: "#218838",
      },
      {
        background: "#fff9e8",
        border: "#f3dfaa",
        color: "#a15c00",
      },
      {
        background: "#fff1f1",
        border: "#ffd4d4",
        color: "#c62828",
      },
      {
        background: "#f5efff",
        border: "#dfd3ff",
        color: "#5b21b6",
      },
      {
        background: "#eef4ff",
        border: "#dce7fa",
        color: "#315fc7",
      },
      {
        background: "#eefbf2",
        border: "#ccebd5",
        color: "#218838",
      },
    ];

    const key = String(value || "N/A");

    let hash = 0;

    for (let i = 0; i < key.length; i++) {
      hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }

    return styles[hash % styles.length];
  };

  // ============================================
  // VEHICLE SUMMARY
  // Company + Feet + Category + Ageing
  // Exclude Inactive Vehicles
  // ============================================
  const getVehicleSummary = (vehicles = []) => {
    const companyCounts = {};
    const feetCounts = {};
    const categoryCounts = {};
    const pendingReasonCounts = {};

    const ageingCounts = {
      "Below 5 Days": 0,
      "5 - 20 Days": 0,
      "21 - 30 Days": 0,
      "Above 30 Days": 0,
    };

    vehicles
      .filter((vehicle) => vehicle.status !== "Inactive")
      .forEach((vehicle) => {
        // Company
        const company = vehicle.id_type?.company || "N/A";

        companyCounts[company] = (companyCounts[company] || 0) + 1;

        // Feet
        const feet = vehicle.id_type?.feet ?? "N/A";
        const feetKey = String(feet);

        feetCounts[feetKey] = (feetCounts[feetKey] || 0) + 1;

        // Category
        const category = vehicle.latestTicket?.category?.name || "N/A";

        categoryCounts[category] = (categoryCounts[category] || 0) + 1;

        // Pending Reason
        const pendingReason =
          vehicle.latestTicket?.pendingissue?.trim() || "N/A";

        pendingReasonCounts[pendingReason] =
          (pendingReasonCounts[pendingReason] || 0) + 1;

        // Ageing
        const aging = Number(vehicle.latestTicket?.aging || 0);

        if (aging < 5) {
          ageingCounts["Below 5 Days"]++;
        } else if (aging >= 5 && aging <= 20) {
          ageingCounts["5 - 20 Days"]++;
        } else if (aging >= 21 && aging <= 30) {
          ageingCounts["21 - 30 Days"]++;
        } else if (aging > 30) {
          ageingCounts["Above 30 Days"]++;
        }
      });

    return {
      companyCounts,
      feetCounts,
      categoryCounts,
      pendingReasonCounts,
      ageingCounts,
    };
  };

  const {
    companyCounts,
    feetCounts,
    categoryCounts,
    pendingReasonCounts,
    ageingCounts,
  } = getVehicleSummary(fullData);

  useEffect(() => {
    if (!fullData.length) return;

    const activeVehicles = fullData.filter(
      (vehicle) => vehicle.status === "Active",
    );

    const serviceCenterVehicles = fullData.filter(
      (vehicle) => vehicle.status === "Service_Center",
    );

    setActiveCount(activeVehicles.length);
    setServiceCenterCount(serviceCenterVehicles.length);
  }, [fullData]);

  return (
    <>
      <Layouts />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateVehicle={updateVehicle}
      />
      <VehicleDetailModal
        show={showVehicleDetailModal}
        onHide={() => setShowVehicleDetailModal(false)}
        vehicle={selectedVehicle}
      />
      <Modal
        show={showCommentsModal}
        onHide={() => setShowCommentsModal(false)}
        size="xl"
        centered
        dialogClassName="ticket-detail-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ticket Comments
            {selectedTicket?.vehicle_number
              ? ` - ${selectedTicket.vehicle_number}`
              : ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!selectedTicket ? (
            <p className="text-muted mb-0">No open ticket available.</p>
          ) : selectedTicketComments.length > 0 ? (
            <div className="d-flex flex-column gap-2">
              {selectedTicketComments.flatMap((comment, index) => {
                let parsedComments;

                try {
                  parsedComments = JSON.parse(comment.text);

                  if (!Array.isArray(parsedComments)) {
                    throw new Error();
                  }
                } catch {
                  parsedComments = [
                    {
                      text: comment.text,
                      date: comment.date,
                    },
                  ];
                }

                return parsedComments.map((c, subIndex) => {
                  const dateObj = c.date ? new Date(c.date) : null;

                  return (
                    <div
                      key={`${comment._id || index}-${subIndex}`}
                      className="p-2 border rounded bg-light"
                      style={{
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      <textarea
                        className="form-control"
                        value={c.text || ""}
                        readOnly
                        rows={Math.min(
                          Math.max((c.text || "").split("\n").length + 2, 4),
                          12,
                        )}
                        style={{
                          resize: "vertical",
                          backgroundColor: "#fff",
                          fontFamily: "monospace",
                          whiteSpace: "pre-wrap",
                          overflowY: "auto",
                        }}
                      />

                      {dateObj && (
                        <div
                          className="text-muted mt-1"
                          style={{
                            fontSize: "0.8em",
                          }}
                        >
                          {dateObj.toLocaleString(undefined, {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                          })}

                          <span
                            style={{
                              color: "red",
                              marginLeft: "20px",
                            }}
                          >
                            Updated{" "}
                            {formatDistanceToNow(dateObj, {
                              addSuffix: true,
                            })}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                });
              })}
            </div>
          ) : (
            <p className="text-muted mb-0">No comments available</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCommentsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              {/* <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1" > */}
              <div
                className="card-header d-flex align-items-center border-bottom pb-1"
                style={{
                  gap: "15px",
                  minHeight: "70px",
                  overflow: "hidden",
                }}
              >
                {/* <h4>{title}</h4> */}
                <h4
                  style={{
                    margin: 0,
                    minWidth: "130px",
                    fontSize: "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {title}
                </h4>
                {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
                <div
                  className="d-flex align-items-center"
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{
                      gap: "10px",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                      flex: "1",
                      minWidth: 0,
                    }}
                  >
                    {/* Moving */}
                    <button
                      onClick={() => handleFilterClick("moving")}
                      style={{
                        height: "48px",
                        minWidth: "125px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #ddd",
                        background: "#f8f9fa",
                        border: "1px solid #dfe3e8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#f1f3f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPlay}
                          style={{ color: "#555", fontSize: "13px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#333" }}>
                        <b>Moving</b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#ddd",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#111" }}>
                        {dashboardCounts.moving}
                      </strong>
                    </button>

                    {/* Not Moving */}
                    <button
                      onClick={() => handleFilterClick("notMoving")}
                      style={{
                        height: "48px",
                        minWidth: "135px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #ddd",
                        background: "#f8f9fa",
                        border: "1px solid #dfe3e8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#f1f3f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPause}
                          style={{ color: "#555", fontSize: "13px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#333" }}>
                        <b> Not Moving</b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#ddd",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#111" }}>
                        {dashboardCounts.notMoving}
                      </strong>
                    </button>

                    {/* Total */}
                    <button
                      onClick={() => handleFilterClick("total")}
                      style={{
                        height: "48px",
                        minWidth: "120px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #ddd",
                        background: "#f8f9fa",
                        border: "1px solid #dfe3e8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#f1f3f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faTruck}
                          style={{ color: "#555", fontSize: "14px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#333" }}>
                        <b> Total</b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#ddd",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#111" }}>
                        {dashboardCounts.total}
                      </strong>
                    </button>

                    {/* Checked-In */}
                    <button
                      onClick={() => handleFilterClick("checkedIn")}
                      style={{
                        height: "48px",
                        minWidth: "135px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #ddd",
                        background: "#f8f9fa",
                        border: "1px solid #dfe3e8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#f1f3f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faUser}
                          style={{ color: "#555", fontSize: "13px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#333" }}>
                        <b>Checked-In</b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#ddd",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#111" }}>
                        {dashboardCounts.checkedIn}
                      </strong>
                    </button>

                    {/* Active */}
                    <button
                      onClick={() => handleStatusFilter("Active")}
                      style={{
                        height: "48px",
                        minWidth: "120px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #b8e5c1",
                        background: "#f0fbf3",
                        border: "1px solid #b8e5c1",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#e9f9ed",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faBolt}
                          style={{ color: "#18a94b", fontSize: "14px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#16863d" }}>
                        <b> Active </b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#cfe8d4",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#16863d" }}>
                        {activeCount}
                      </strong>
                    </button>

                    {/* Service Center */}
                    <button
                      onClick={() => handleStatusFilter("Service_Center")}
                      style={{
                        height: "48px",
                        minWidth: "155px",
                        padding: "0 12px",
                        // background: "#fff",
                        // border: "1px solid #f2d49b",
                        background: "#fff8e9",
                        border: "1px solid #f2d49b",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#fff5df",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faWrench}
                          style={{ color: "#d88900", fontSize: "14px" }}
                        />
                      </div>

                      <span style={{ fontSize: "14px", color: "#c47700" }}>
                        <b>Service Center</b>
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#efdcb7",
                        }}
                      />

                      <strong style={{ fontSize: "16px", color: "#c47700" }}>
                        {serviceCenterCount}
                      </strong>
                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  {userRole === "superadmin" && (
                    <Link to="/create-vehicle">
                      <div className="btn btn-info btn-sm text-white me-2">
                        Add Vehicle
                      </div>
                    </Link>
                  )}
                  {userRole === "superadmin" && (
                    <>
                      <button
                        onClick={exportToExcel}
                        className="btn btn-success btn-sm me-2"
                      >
                        Export to Excel
                      </button>
                      <button
                        onClick={sendServiceCenterEmail}
                        className="btn btn-warning btn-sm me-2"
                      >
                        Send Service Center Email
                      </button>
                    </>
                  )}
                </div>
              </div>
              {/* ============================================
    VEHICLE SUMMARY
============================================ */}
              {/* ============================================
    VEHICLE SUMMARY
============================================ */}
              {statusFilter === "Service_Center" && (
                <div
                  className="px-3 pt-3"
                  style={{
                    width: "100%",
                    fontFamily:
                      "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      background: "#ffffff",
                      border: "1px solid #e1e5ee",
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 1px 4px rgba(31, 41, 55, 0.04)",
                    }}
                  >
                    {/* =========================================================
          HEADER
      ========================================================= */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "16px 20px",
                        background: "#f8f9ff",
                        borderBottom: "1px solid #e6e9f0",
                      }}
                    >
                      {/* LEFT */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            width: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            background: "#eee9ff",
                            color: "#4723d9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTruck}
                            style={{
                              fontSize: "17px",
                            }}
                          />
                        </div>

                        <div>
                          <div
                            style={{
                              fontSize: "17px",
                              fontWeight: "700",
                              color: "#172033",
                              lineHeight: "22px",
                            }}
                          >
                            Vehicle Summary
                          </div>

                          <div
                            style={{
                              fontSize: "11px",
                              fontWeight: "400",
                              color: "#7a8496",
                              marginTop: "3px",
                              lineHeight: "16px",
                            }}
                          >
                            Vehicle distribution by Company, Feet, Vehicle
                            Category, Ageing and Pending Reason
                          </div>
                        </div>
                      </div>

                      {/* TOTAL VEHICLES */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px 13px",
                          borderRadius: "8px",
                          background: "#f4f0ff",
                          border: "1px solid #ded5ff",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color: "#6d5ca8",
                          }}
                        >
                          Total Vehicles
                        </span>

                        <span
                          style={{
                            fontSize: "18px",
                            lineHeight: "20px",
                            fontWeight: "800",
                            color: "#4723d9",
                          }}
                        >
                          {
                            fullData.filter(
                              (vehicle) => vehicle.status !== "Inactive",
                            ).length
                          }
                        </span>
                      </div>
                    </div>

                    {/* =========================================================
          MAIN SUMMARY CARDS
      ========================================================= */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1.05fr 0.78fr 1.12fr 1.12fr",
                        gap: "12px",
                        padding: "12px",
                        background: "#ffffff",
                      }}
                    >
                      {/* =======================================================
            COMPANY
        ======================================================= */}
                      <div
                        style={{
                          background: "#f5f3ff",
                          border: "1px solid #e3ddff",
                          borderRadius: "12px",
                          padding: "14px",
                          minWidth: 0,
                        }}
                      >
                        {/* TITLE */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "7px",
                              background: "#e9e4ff",
                              color: "#4723d9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTruck}
                              style={{ fontSize: "13px" }}
                            />
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#172554",
                            }}
                          >
                            By Company
                          </span>
                        </div>

                        {/* COMPANY VALUES */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                            gap: "8px",
                          }}
                        >
                          {Object.entries(companyCounts)
                            .sort(([a], [b]) => a.localeCompare(b))
                            .map(([company, count]) => {
                              const style = getDynamicStyle(company);

                              const isSelected =
                                vehicleSummaryCompanyFilter === company;

                              return (
                                <button
                                  key={company}
                                  type="button"
                                  title={
                                    isSelected
                                      ? `Remove filter: ${company}`
                                      : `Filter by ${company}`
                                  }
                                  onClick={() => {
                                    setVehicleSummaryCompanyFilter(
                                      isSelected ? "" : company,
                                    );
                                    setCurrentPage(1);
                                  }}
                                  style={{
                                    minHeight: "54px",
                                    padding: "7px 8px",
                                    borderRadius: "8px",

                                    background: isSelected
                                      ? style.border
                                      : style.background,

                                    border: `1px solid ${style.border}`,

                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    minWidth: 0,
                                    width: "100%",

                                    outline: "none",
                                    fontFamily: "inherit",
                                    cursor: "pointer",

                                    transition:
                                      "background 0.15s ease, transform 0.15s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      fontSize: "11px",
                                      fontWeight: "500",
                                      color: "#334155",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {company}
                                  </span>

                                  <strong
                                    style={{
                                      marginTop: "3px",
                                      fontSize: "17px",
                                      lineHeight: "18px",
                                      fontWeight: "800",
                                      color: style.color,
                                    }}
                                  >
                                    {count}
                                  </strong>
                                </button>
                              );
                            })}
                        </div>
                      </div>

                      {/* =======================================================
            FEET
        ======================================================= */}
                      <div
                        style={{
                          background: "#eef7ff",
                          border: "1px solid #d8eaff",
                          borderRadius: "12px",
                          padding: "14px",
                          minWidth: 0,
                        }}
                      >
                        {/* TITLE */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "7px",
                              background: "#e1f0ff",
                              color: "#0878d1",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTruck}
                              style={{ fontSize: "13px" }}
                            />
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#123f70",
                            }}
                          >
                            By Feet
                          </span>
                        </div>

                        {/* FEET VALUES */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "8px",
                          }}
                        >
                          {Object.entries(feetCounts)
                            .sort(([a], [b]) => {
                              if (a === "N/A") return 1;
                              if (b === "N/A") return -1;

                              return Number(a) - Number(b);
                            })
                            .map(([feet, count]) => {
                              const style = getDynamicStyle(feet);

                              const isSelected = vehicleFeetFilter === feet;

                              return (
                                <button
                                  key={feet}
                                  type="button"
                                  title={
                                    isSelected
                                      ? `Remove filter: ${feet}`
                                      : `Filter by ${feet}`
                                  }
                                  onClick={() => {
                                    setVehicleFeetFilter(
                                      isSelected ? "" : feet,
                                    );
                                    setCurrentPage(1);
                                  }}
                                  style={{
                                    minHeight: "54px",
                                    padding: "7px 8px",
                                    borderRadius: "8px",

                                    background: isSelected
                                      ? style.border
                                      : style.background,

                                    border: `1px solid ${style.border}`,

                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    minWidth: 0,
                                    width: "100%",

                                    outline: "none",
                                    fontFamily: "inherit",
                                    cursor: "pointer",

                                    transition:
                                      "background 0.15s ease, transform 0.15s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "500",
                                      color: "#334155",
                                    }}
                                  >
                                    {feet === "N/A" ? "N/A" : `${feet} Feet`}
                                  </span>

                                  <strong
                                    style={{
                                      marginTop: "3px",
                                      fontSize: "17px",
                                      lineHeight: "18px",
                                      fontWeight: "800",
                                      color: style.color,
                                    }}
                                  >
                                    {count}
                                  </strong>
                                </button>
                              );
                            })}
                        </div>
                      </div>

                      {/* =======================================================
            CATEGORY
        ======================================================= */}
                      <div
                        style={{
                          background: "#effaf2",
                          border: "1px solid #d8efdc",
                          borderRadius: "12px",
                          padding: "14px",
                          minWidth: 0,
                        }}
                      >
                        {/* TITLE */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "7px",
                              background: "#e2f4e6",
                              color: "#218838",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faWrench}
                              style={{ fontSize: "13px" }}
                            />
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#14532d",
                            }}
                          >
                            By Category
                          </span>
                        </div>

                        {/* CATEGORY VALUES */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                            gap: "8px",
                          }}
                        >
                          {Object.entries(categoryCounts)
                            .sort(([a], [b]) => a.localeCompare(b))
                            .map(([category, count]) => {
                              const style = getDynamicStyle(category);

                              const isSelected =
                                ticketCategoryFilter === category;

                              return (
                                <button
                                  key={category}
                                  type="button"
                                  title={
                                    isSelected
                                      ? `Remove filter: ${category}`
                                      : `Filter by ${category}`
                                  }
                                  onClick={() => {
                                    setTicketCategoryFilter(
                                      isSelected ? "" : category,
                                    );
                                    setCurrentPage(1);
                                  }}
                                  style={{
                                    minHeight: "54px",
                                    padding: "7px 8px",
                                    borderRadius: "8px",

                                    background: isSelected
                                      ? style.border
                                      : style.background,

                                    border: `1px solid ${style.border}`,

                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    minWidth: 0,
                                    width: "100%",

                                    outline: "none",
                                    fontFamily: "inherit",
                                    cursor: "pointer",

                                    transition:
                                      "background 0.15s ease, transform 0.15s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      color: style.color,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {category}
                                  </span>

                                  <strong
                                    style={{
                                      marginTop: "3px",
                                      fontSize: "17px",
                                      lineHeight: "18px",
                                      fontWeight: "800",
                                      color: style.color,
                                    }}
                                  >
                                    {count}
                                  </strong>
                                </button>
                              );
                            })}
                        </div>
                      </div>

                      {/* =======================================================
            AGEING
        ======================================================= */}
                      <div
                        style={{
                          background: "#fff8ed",
                          border: "1px solid #f2dfc1",
                          borderRadius: "12px",
                          padding: "14px",
                          minWidth: 0,
                        }}
                      >
                        {/* TITLE */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "7px",
                              background: "#fff0d8",
                              color: "#c47700",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faHistory}
                              style={{ fontSize: "13px" }}
                            />
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "700",
                              color: "#8a5700",
                            }}
                          >
                            By Ageing
                          </span>
                        </div>

                        {/* AGEING VALUES */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                            gap: "8px",
                          }}
                        >
                          {/* {Object.entries(ageingCounts).map(
                            ([ageing, count]) => (
                              <div
                                key={ageing}
                                style={{
                                  minHeight: "54px",
                                  padding: "7px 8px",
                                  borderRadius: "8px",
                                  background: "#ffffff",
                                  border: "1px solid #f1dfc4",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <span
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    color: "#8a5700",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={ageing}
                                >
                                  {ageing}
                                </span>

                                <strong
                                  style={{
                                    marginTop: "3px",
                                    fontSize: "17px",
                                    lineHeight: "18px",
                                    fontWeight: "800",
                                    color: "#c47700",
                                  }}
                                >
                                  {count}
                                </strong>
                              </div>
                            ),
                          )} */}

                          {Object.entries(ageingCounts).map(
                            ([ageing, count]) => {
                              const isSelected = ticketAgingFilter === ageing;

                              return (
                                <button
                                  key={ageing}
                                  type="button"
                                  title={
                                    isSelected
                                      ? `Remove filter: ${ageing}`
                                      : `Filter by ${ageing}`
                                  }
                                  onClick={() => {
                                    setTicketAgingFilter(
                                      isSelected ? "" : ageing,
                                    );
                                    setCurrentPage(1);
                                  }}
                                  style={{
                                    minHeight: "54px",
                                    padding: "7px 8px",
                                    borderRadius: "8px",

                                    background: isSelected
                                      ? "#f1d8ad"
                                      : "#ffffff",

                                    border: "1px solid #f1dfc4",

                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    minWidth: 0,
                                    width: "100%",

                                    outline: "none",
                                    fontFamily: "inherit",
                                    cursor: "pointer",

                                    transition:
                                      "background 0.15s ease, transform 0.15s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(-1px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateY(0)";
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      color: "#8a5700",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    title={ageing}
                                  >
                                    {ageing}
                                  </span>

                                  <strong
                                    style={{
                                      marginTop: "3px",
                                      fontSize: "17px",
                                      lineHeight: "18px",
                                      fontWeight: "800",
                                      color: "#c47700",
                                    }}
                                  >
                                    {count}
                                  </strong>
                                </button>
                              );
                            },
                          )}
                        </div>
                      </div>
                    </div>

                    {/* =========================================================
          PENDING REASON
      ========================================================= */}
                    <div
                      style={{
                        margin: "0 12px 12px",
                        padding: "14px",
                        borderRadius: "12px",
                        background: "#eef4ff",
                        border: "1px solid #dce7fa",
                      }}
                    >
                      {/* TITLE */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "7px",
                            background: "#e2ebff",
                            color: "#315fc7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            style={{ fontSize: "13px" }}
                          />
                        </div>

                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "700",
                            color: "#263f79",
                          }}
                        >
                          By Pending Reason
                        </span>
                      </div>

                      {/* PENDING REASON VALUES */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(145px, 1fr))",
                          gap: "8px",
                        }}
                      >
                        {Object.entries(pendingReasonCounts)
                          .sort(([a], [b]) => a.localeCompare(b))
                          .map(([reason, count]) => {
                            const style = getDynamicStyle(reason);

                            const isSelected =
                              ticketPendingReasonFilter === reason;

                            return (
                              <button
                                key={reason}
                                type="button"
                                title={
                                  isSelected
                                    ? `Remove filter: ${reason}`
                                    : `Filter by ${reason}`
                                }
                                onClick={() => {
                                  setTicketPendingReasonFilter(
                                    isSelected ? "" : reason,
                                  );
                                  setCurrentPage(1);
                                }}
                                style={{
                                  minHeight: "48px",
                                  padding: "8px 11px",
                                  borderRadius: "8px",

                                  // Highlight selected filter
                                  background: isSelected
                                    ? style.border
                                    : style.background,

                                  border: `1px solid ${style.border}`,

                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                  minWidth: 0,
                                  width: "100%",

                                  // Button reset
                                  outline: "none",
                                  fontFamily: "inherit",

                                  // Clickable
                                  cursor: "pointer",

                                  textAlign: "left",

                                  transition:
                                    "background 0.15s ease, transform 0.15s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-1px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(0)";
                                }}
                              >
                                {/* REASON TEXT */}
                                <span
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    color: style.color,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {reason}
                                </span>

                                {/* COUNT */}
                                <strong
                                  style={{
                                    minWidth: "24px",
                                    height: "22px",
                                    padding: "0 6px",
                                    borderRadius: "5px",
                                    background: "#ffffff",
                                    border: `1px solid ${style.border}`,
                                    color: style.color,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "800",
                                    flexShrink: 0,
                                  }}
                                >
                                  {count}
                                </strong>
                              </button>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="card-body">
                <DataTable_Component
                  searchBy="numberplate"
                  title_btn={true}
                  title="Vehicle List"
                  apidata={apistate}
                  columns={apicol}
                  // onFilteredDataChange={handleFilteredDataChange}
                  totalRows={totalRows}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  dataFilter={dataFilter}
                  setDataFilter={setDataFilter}
                  statusFilter={statusFilter}
                  setStatusFilter={setStatusFilter}
                  vehicleCompanyFilter={vehicleCompanyFilter}
                  setVehicleCompanyFilter={setVehicleCompanyFilter}
                  hubFilter={hubFilter}
                  setHubFilter={setHubFilter}
                  monthFilter={monthFilter}
                  setMonthFilter={setMonthFilter}
                  ticketCategoryFilter={ticketCategoryFilter}
                  setTicketCategoryFilter={setTicketCategoryFilter}
                  ticketAgingFilter={ticketAgingFilter}
                  setTicketAgingFilter={setTicketAgingFilter}
                  ticketPendingReasonFilter={ticketPendingReasonFilter}
                  setTicketPendingReasonFilter={setTicketPendingReasonFilter}
                  leasingPartnerFilter={leasingPartnerFilter}
                  setLeasingPartnerFilter={setLeasingPartnerFilter}
                  leasingPartners={leasingPartners}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
